import cx from 'classnames/bind';
import React from 'react';
import styles from './MailReadingPaneHeader.scss';
import { Header } from 'mini-header';

const classNames = cx.bind(styles);

/* eslint-disable-next-line @typescript-eslint/no-unused-vars --
 * See aka.ms/mini-lint-errors
 *	> 'props' is defined but never used. */
export const MailReadingPaneHeaderPlaceholder: React.FC<{}> = props => (
    <Header className={classNames(styles.mailReadingPaneHeader)} />
);
